define('../app/fukit/view/block/content.management.item.view',['require','exports','module','../../behavior/bind.and.format.option.values.behavior','../../helpers/formatter','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var BindAndFormatOptionValuesBehavior = require('../../behavior/bind.and.format.option.values.behavior'),
      Formatter                         = require('../../helpers/formatter'),
      UIKit                             = require('uikit/uikit');

  var ContentManagementItemView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="contentTitleView"/><ui name="contentMessageView"/><br/><ui name="contentMetadataView"/>';
    },

    options: {
      attributeMap: null
    },

    internalViewOptions: {
      contentTitleView: function() {
        return {
          type: UIKit.Header.extend({
            className: UIKit.Header.prototype.className + ' title',

            initialize: function() {
              UIKit.Header.prototype.initialize.apply(this, arguments);

              this.listenTo(this.model, 'change:' + this.getOption('titleAttribute'), function() {
                this.$el.attr('title', this.model.get(this.getOption('titleAttribute')));
              })
            },
          }),
          tagName: 'h5',
          model: this.model,
          titleAttribute: this.getModelAttributeFromMap('title'),
          bindings: {
            text: this.getModelAttributeFromMap('title')
          },
          attributes: {
            style: 'margin: 0',
            title: this.model.get(this.getModelAttributeFromMap('title'))
          },
          formatter: Formatter.richTextToSingleLine()
        }
      },
      contentMessageView: function() {
        return {
          type: UIKit.Text.extend({
            tagName: 'div',
            className: UIKit.Text.prototype.className + ' body'
          }),
          model: this.model,
          bindings: {
            text: this.getModelAttributeFromMap('body')
          },
          formatter: Formatter.richTextToSingleLine()
        }
      },
      contentMetadataView: function() {
        return {
          type: UIKit.ItemView.extend({
            template: function() {
              return '<ui name="nameView"/><ui name="dateView"/>'
            },

            className: 'metadata',

            behaviors: {
              BindAndFormatOptionValuesBehavior: {
                optionValues: {
                  visible: {
                    modelAttribute: 'id',
                    formatter: Formatter.toBoolean()
                  }
                },
                behaviorClass: BindAndFormatOptionValuesBehavior
              }
            },

            internalViewOptions: {
              nameView: function() {
                return {
                  type: UIKit.Text,
                  model: this.model,
                  bindings: {
                    text: this.getOption('createdByNameAttribute'),
                  },
                  formatter: function(value) {
                    if (value && value!= 'undefined undefined') {
                      return value + ' on ';
                    }
                    else {
                      return '';
                    }
                  }
                }
              },
              dateView: function() {
                return {
                  type: UIKit.Text,
                  model: this.model,
                  bindings: {
                    text: this.getOption('createdOnAttribute')
                  },
                  formatter: Formatter.date('L LT')
                }
              }
            }
          }),
          model: this.model,
          createdByNameAttribute: this.getModelAttributeFromMap('createdByName'),
          createdOnAttribute: this.getModelAttributeFromMap('createdOn')
        }
      }
    },

    getModelAttributeFromMap: function(attribute) {
      return this.getOption('attributeMap')[attribute] || '';
    }
  });

  module.exports = ContentManagementItemView;
});

